/* Orvia · original code by Stellar Virtex */
(() => {
  const cfg = window.StellarTheme || { routes: {}, strings: {} };
  const routes = cfg.routes || {};
  const designMode = window.Shopify && window.Shopify.designMode;

  const formatMoney = (cents) => {
    const format = cfg.moneyFormat || '{{amount}}';
    const value = (cents / 100);
    const withDelims = (n, dec, thou, sep) => {
      const [i, d] = n.toFixed(dec).split('.');
      return i.replace(/\B(?=(\d{3})+(?!\d))/g, thou) + (d ? sep + d : '');
    };
    return format.replace(/\{\{\s*(\w+)\s*\}\}/, (_, key) => {
      switch (key) {
        case 'amount_no_decimals': return withDelims(value, 0, ',', '.');
        case 'amount_with_comma_separator': return withDelims(value, 2, '.', ',');
        case 'amount_no_decimals_with_comma_separator': return withDelims(value, 0, '.', ',');
        case 'amount_with_apostrophe_separator': return withDelims(value, 2, "'", '.');
        default: return withDelims(value, 2, ',', '.');
      }
    });
  };

  const focusable = (root) => [...root.querySelectorAll('a[href], button:not([disabled]), input:not([disabled]):not([type="hidden"]), select, textarea, [tabindex]:not([tabindex="-1"])')]
    .filter((el) => el.offsetParent !== null);

  const trapFocus = (root, event) => {
    if (event.key !== 'Tab') return;
    const items = focusable(root);
    if (!items.length) return;
    const first = items[0], last = items[items.length - 1];
    if (event.shiftKey && document.activeElement === first) { last.focus(); event.preventDefault(); }
    else if (!event.shiftKey && document.activeElement === last) { first.focus(); event.preventDefault(); }
  };

  /* ---------- Cart ---------- */
  const updateCount = async () => {
    try {
      const cart = await (await fetch(`${routes.cart}.js`)).json();
      document.querySelectorAll('[data-cart-count]').forEach((el) => {
        el.textContent = cart.item_count;
        el.hidden = cart.item_count === 0;
      });
    } catch (e) { /* ignore */ }
  };

  const renderDrawer = (html) => {
    const drawer = document.querySelector('cart-drawer');
    if (!drawer || !html) return;
    const doc = new DOMParser().parseFromString(html, 'text/html');
    const fresh = doc.querySelector('.cart-drawer__panel');
    const panel = drawer.querySelector('.cart-drawer__panel');
    const oldTrack = panel && panel.querySelector('[data-fs-track]');
    const oldPct = oldTrack ? oldTrack.dataset.pct : null;
    if (fresh && panel) panel.innerHTML = fresh.innerHTML;
    const track = panel && panel.querySelector('[data-fs-track]');
    if (track && oldPct !== null && oldPct !== track.dataset.pct && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      const done = track.classList.contains('is-complete');
      track.classList.remove('is-complete');
      track.style.setProperty('--fs-pct', `${oldPct}%`);
      void track.offsetWidth;
      track.classList.add('is-moving');
      track.style.setProperty('--fs-pct', `${track.dataset.pct}%`);
      setTimeout(() => {
        track.classList.remove('is-moving');
        if (done) track.classList.add('is-complete', 'is-arrived');
      }, 700);
    }
    drawer.loadRecommendations();
  };

  const addToCart = async (body, button) => {
    if (button) button.setAttribute('aria-busy', 'true');
    try {
      const res = await fetch(`${routes.cartAdd}.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ ...body, sections: 'cart-drawer', sections_url: window.location.pathname })
      });
      const data = await res.json();
      if (!res.ok) throw new Error(data.description || data.message || cfg.strings.error);
      const drawer = document.querySelector('cart-drawer');
      if (drawer && drawer.enabled) {
        renderDrawer(data.sections && data.sections['cart-drawer']);
        drawer.open(button);
      } else {
        window.location.href = routes.cart;
        return;
      }
      updateCount();
    } catch (err) {
      window.alert(err.message || cfg.strings.error);
    } finally {
      if (button) button.removeAttribute('aria-busy');
    }
  };

  document.addEventListener('submit', (event) => {
    const form = event.target;
    if (!form.matches('[data-cart-form]')) return;
    const drawer = document.querySelector('cart-drawer');
    const fd = new FormData(form);
    const extras = fd.getAll('extra_items[]').filter(Boolean);
    if ((!drawer || !drawer.enabled) && !extras.length) return;
    event.preventDefault();
    const item = { id: Number(fd.get('id')), quantity: Number(fd.get('quantity') || 1) };
    if (fd.get('selling_plan')) item.selling_plan = Number(fd.get('selling_plan'));
    const props = {};
    for (const [k, v] of fd.entries()) {
      const m = k.match(/^properties\[(.+)\]$/);
      if (m) props[m[1]] = v;
    }
    if (Object.keys(props).length) item.properties = props;
    const items = [item, ...extras.map((id) => ({ id: Number(id), quantity: 1 }))];
    addToCart({ items }, event.submitter || form.querySelector('[type="submit"]'));
  });

  class CartDrawer extends HTMLElement {
    connectedCallback() {
      this.enabled = this.dataset.enabled === 'true';
      this.addEventListener('click', (e) => { if (e.target.closest('[data-cart-close]')) this.close(); });
      this.addEventListener('keydown', (e) => {
        if (e.key === 'Escape') this.close();
        trapFocus(this.querySelector('.cart-drawer__panel'), e);
      });
      this.addEventListener('change', (e) => {
        const input = e.target.closest('[data-cart-qty]');
        if (input) this.changeLine(input.dataset.line, Number(input.value));
      });
      this.addEventListener('click', (e) => {
        const remove = e.target.closest('[data-cart-remove]');
        if (remove) { e.preventDefault(); this.changeLine(remove.dataset.line, 0); }
      });
      this.addEventListener('submit', (e) => {
        const coupon = e.target.closest('[data-coupon-form]');
        if (!coupon) return;
        e.preventDefault();
        const code = coupon.querySelector('input').value.trim();
        if (code) this.setDiscounts([...this.currentCodes(), code], code);
      });
      this.addEventListener('change', async (e) => {
        const gift = e.target.closest('[data-gift-wrap]');
        if (gift) {
          if (!gift.checked && Number(gift.dataset.giftLine) > 0) { this.changeLine(gift.dataset.giftLine, 0); return; }
          if (gift.checked) {
            this.setAttribute('aria-busy', 'true');
            try {
              const res = await fetch(`${routes.cartAdd}.js`, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: [{ id: Number(gift.dataset.giftWrap), quantity: 1 }], sections: 'cart-drawer', sections_url: window.location.pathname }) });
              const data = await res.json();
              if (!res.ok) throw new Error(data.description || cfg.strings.error);
              renderDrawer(data.sections && data.sections['cart-drawer']);
              updateCount();
            } catch (err) { gift.checked = false; window.alert(err.message || cfg.strings.error); } finally { this.removeAttribute('aria-busy'); }
          }
          return;
        }
        const msg = e.target.closest('[data-gift-message]');
        if (msg) fetch(`${routes.cart}/update.js`, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ attributes: { 'Gift message': msg.value.slice(0, 250) } }) });
      });
      this.addEventListener('click', (e) => {
        const rm = e.target.closest('[data-coupon-remove]');
        if (rm) this.setDiscounts(this.currentCodes().filter((c) => c !== rm.dataset.couponRemove));
      });
      this.addEventListener('change', (e) => {
        const note = e.target.closest('[data-cart-note]');
        if (note) fetch(`${routes.cart}/update.js`, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ note: note.value }) });
      });
      document.addEventListener('click', (e) => {
        const toggle = e.target.closest('[data-cart-toggle]');
        if (toggle && this.enabled) { e.preventDefault(); this.open(toggle); }
      });
    }
    open(trigger) {
      this.trigger = trigger || document.activeElement;
      this.hidden = false;
      requestAnimationFrame(() => this.classList.add('is-open'));
      document.body.classList.add('overflow-hidden');
      this.querySelector('.cart-drawer__panel').focus();
      this.loadRecommendations();
      document.dispatchEvent(new CustomEvent('cart-drawer:open'));
    }
    close() {
      this.classList.remove('is-open');
      document.body.classList.remove('overflow-hidden');
      setTimeout(() => { this.hidden = true; }, 250);
      if (this.trigger && this.trigger.focus) this.trigger.focus();
    }
    async changeLine(line, quantity) {
      this.setAttribute('aria-busy', 'true');
      try {
        const res = await fetch(`${routes.cartChange}.js`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ line: Number(line), quantity, sections: 'cart-drawer', sections_url: window.location.pathname })
        });
        const data = await res.json();
        if (!res.ok) throw new Error(data.description || cfg.strings.error);
        renderDrawer(data.sections && data.sections['cart-drawer']);
        updateCount();
        this.querySelector('.cart-drawer__panel').focus();
      } catch (err) {
        window.alert(err.message || cfg.strings.error);
      } finally {
        this.removeAttribute('aria-busy');
      }
    }
    currentCodes() {
      return [...this.querySelectorAll('[data-coupon-remove]')].map((b) => b.dataset.couponRemove);
    }
    async setDiscounts(codes, added) {
      this.setAttribute('aria-busy', 'true');
      try {
        const res = await fetch(`${routes.cart}/update.js`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ discount: codes.join(','), sections: 'cart-drawer', sections_url: window.location.pathname })
        });
        const data = await res.json();
        renderDrawer(data.sections && data.sections['cart-drawer']);
        const bad = added && (data.discount_codes || []).find((d) => d.code.toLowerCase() === added.toLowerCase() && !d.applicable);
        const msg = this.querySelector('[data-coupon-error]');
        if (bad && msg) { msg.hidden = false; msg.focus(); }
      } catch (err) {
        window.alert(cfg.strings.error);
      } finally {
        this.removeAttribute('aria-busy');
      }
    }
    loadRecommendations() {
      const recs = this.querySelector('product-recommendations');
      if (recs && !this.hidden) recs.load();
    }
  }
  customElements.define('cart-drawer', CartDrawer);
  document.addEventListener('click', (e) => {
    const top = e.target.closest('[data-back-to-top]');
    if (top) { e.preventDefault(); window.scrollTo({ top: 0, behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' }); document.getElementById('MainContent').focus({ preventScroll: true }); }
  });

  /* ---------- Recommendations (Shopify product recommendations API) ---------- */
  class ProductRecommendations extends HTMLElement {
    connectedCallback() {
      if (this.closest('cart-drawer')) return;
      const io = new IntersectionObserver((entries) => {
        if (entries.some((e) => e.isIntersecting)) { io.disconnect(); this.load(); }
      }, { rootMargin: '0px 0px 400px 0px' });
      io.observe(this);
    }
    async load(url = this.dataset.url, fallback = true) {
      if (this.loaded || !url) return;
      try {
        const html = await (await fetch(url)).text();
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const section = doc.querySelector('.shopify-section');
        const inner = section ? section.querySelector('product-recommendations') || section : null;
        const content = inner ? inner.innerHTML.trim() : '';
        if (!content && fallback && this.dataset.fallbackIntent) {
          return this.load(url.replace(/intent=\w+/, `intent=${this.dataset.fallbackIntent}`), false);
        }
        this.innerHTML = content;
        this.loaded = true;
      } catch (e) { /* ignore */ }
    }
  }
  customElements.define('product-recommendations', ProductRecommendations);

  /* ---------- Product page ---------- */
  class QuantityInput extends HTMLElement {
    connectedCallback() {
      this.input = this.querySelector('input');
      this.addEventListener('click', (e) => {
        const btn = e.target.closest('button');
        if (!btn) return;
        const step = btn.name === 'plus' ? 1 : -1;
        this.input.value = Math.max(Number(this.input.min || 1), Number(this.input.value || 1) + step);
        this.input.dispatchEvent(new Event('change', { bubbles: true }));
      });
    }
  }
  customElements.define('quantity-input', QuantityInput);
  /* ---------- Misc ---------- */
  document.addEventListener('change', (e) => {
    const form = e.target.closest('[data-auto-submit]');
    if (form && e.target.matches('select')) form.submit();
  });
  /* ---------- Quick add modal ---------- */
  let quickDialog;
  const quickSync = (body) => {
    const variants = JSON.parse(body.querySelector('[data-quick-variants]').textContent);
    const chosen = [...body.querySelectorAll('fieldset')].map((f) => { const c = f.querySelector('input:checked'); return c && c.value; });
    const v = variants.find((x) => x.options.every((o, i) => o === chosen[i]));
    const btn = body.querySelector('[data-quick-submit]');
    body.querySelector('input[name="id"]').value = v ? v.id : '';
    btn.disabled = !v || !v.available;
    btn.textContent = v && v.available ? btn.dataset.add : btn.dataset.soldOut;
    const price = body.querySelector('.price__current');
    if (v && price) price.textContent = formatMoney(v.price);
    body.querySelectorAll('fieldset').forEach((f, i) => {
      f.querySelectorAll('input').forEach((input) => {
        const opts = chosen.slice(); opts[i] = input.value;
        const ok = variants.some((x) => x.available && x.options.every((o, j) => o === opts[j]));
        input.nextElementSibling.classList.toggle('is-unavailable', !ok);
      });
    });
  };
  document.addEventListener('click', async (e) => {
    const trigger = e.target.closest('[data-quick-add]');
    if (!trigger) return;
    e.preventDefault();
    if (!quickDialog) {
      quickDialog = document.createElement('dialog');
      quickDialog.className = 'quick-add-modal';
      quickDialog.setAttribute('aria-labelledby', 'QuickAddTitle');
      quickDialog.addEventListener('click', (ev) => { if (ev.target === quickDialog || ev.target.closest('[data-quick-close]')) quickDialog.close(); });
      quickDialog.addEventListener('close', () => quickDialog.querySelectorAll('video').forEach((v) => v.pause()));
      quickDialog.addEventListener('change', () => quickSync(quickDialog));
      quickDialog.addEventListener('submit', () => setTimeout(() => quickDialog.close(), 50));
      document.body.appendChild(quickDialog);
    }
    trigger.setAttribute('aria-busy', 'true');
    try {
      const sep = trigger.dataset.quickAdd.includes('?') ? '&' : '?';
      const html = await (await fetch(`${trigger.dataset.quickAdd}${sep}section_id=quick-add`)).text();
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const body = doc.querySelector('[data-quick-add-body]');
      quickDialog.innerHTML = `<button type="button" class="icon-button quick-add-modal__close" data-quick-close aria-label="${cfg.strings.close || 'Close'}">✕</button>`;
      quickDialog.appendChild(body);
      const btn = body.querySelector('[data-quick-submit]');
      btn.dataset.add = cfg.strings.addToCart; btn.dataset.soldOut = cfg.strings.soldOut;
      quickDialog.showModal();
      if (body.querySelector('model-viewer') && window.Shopify && Shopify.loadFeatures) {
        Shopify.loadFeatures([{ name: 'model-viewer-ui', version: '1.0', onLoad: (err) => {
          if (err) return;
          body.querySelectorAll('model-viewer').forEach((m) => new Shopify.ModelViewerUI(m));
        } }]);
      }
      quickSync(body);
    } finally { trigger.removeAttribute('aria-busy'); }
  });
  Object.assign(cfg, { formatMoney, trapFocus, addToCart, designMode });
})();

/* Orvia · gift card recipient form */
(() => {
  if (customElements.get('gift-card-recipient')) return;
  customElements.define('gift-card-recipient', class extends HTMLElement {
    connectedCallback() {
      const toggle = this.querySelector('[data-gift-recipient-toggle]');
      const panel = this.querySelector('.gift-recipient__fields');
      const offset = this.querySelector('[data-gift-recipient-offset]');
      if (!toggle || !panel) return;
      const sync = () => {
        const on = toggle.checked;
        panel.hidden = !on;
        toggle.setAttribute('aria-expanded', String(on));
        this.querySelectorAll('[data-gift-recipient-field]').forEach((f) => { f.disabled = !on; });
        if (offset) offset.value = String(new Date().getTimezoneOffset() * -60);
      };
      toggle.addEventListener('change', sync);
      sync();
    }
  });
})();
